<template>
  <section>
    <div class="container">

      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Menus storage</h1>
            <h4 class="subtitle">Manage the storage for your menus here.</h4>
          </div>
        </div>
      </div>

<div class="columns is-multiline is-mobile">
        <div class="column is-9 is-offset-1 box" border-color="black">
          <div><b>Menus storage size: </b>{{!totalMenusSize ? (totalMenusSize === 0 ? formatBytes(totalMenusSize, 2) : 'Calculating...') : formatBytes(totalMenusSize, 2)}}</div>
                              <b-progress
            :rounded=0
            :value="menusPercent"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress>

        <div><b>Total storage used: </b>{{!totalStorageSize ? (totalStorageSize === 0 ? formatBytes(totalStorageSize, 2) : 'Calculating...') : formatBytes(totalStorageSize, 2) + '/1 GB'}}</div>
                              <b-progress
            :rounded="false"
            :value="totalPercentUsed"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress>
        <!-- <div><b>Total storage free: </b>{{formatBytes(freeStorageSize, 2)}}/1 GB</div>
<b-progress
            :rounded="false"
            :value="totalPercentFree"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress> -->
          </div>
                  <div></div>
</div>
      <div class="columns is-multiline is-mobile">
        <div class="column is-4 is-offset-1 box" border-color="black" v-for="(menu, menuId) in menus" :key="menuId">
          <div class="level" >
            <div class="level-left">
              <div style="font-size:17.5px;color:#3e8ed0" class="level-item"><b>{{showName(menu.name)}}</b></div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="menu.items && menu.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined).length > 0">
                <b-button type="is-primary is-light" @click="seeResources(menuId, menu.name)">See resources</b-button>
              </div>
              </div>
          </div>

            <p><b>No. of resources:</b> {{numMenRes[menuId] !== undefined ? numMenRes[menuId] : 'Calculating...'}}</p>
            <p><b>Total size:</b> {{totalSizes.find(x => x.key === menuId) !== undefined ? formatBytes(totalSizes.find(x => x.key === menuId).value, 2) : 'Calculating...'}}</p>
        </div>
        <div></div>

                <div class="column is-4 is-offset-1 box" border-color="black">
          <div class="level" >
            <div class="level-left">
              <b-button type="is-ghost" icon-left="trash" style="cursor:auto"></b-button>
              <div style="font-size:17.5px;color:#3e8ed0" class="level-item"><b>Menus archive</b></div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="shouldSeeResources">
                <b-button type="is-primary" @click="seeArchivedResources()">See resources</b-button>
              </div>
              <div class="level-item" v-else>
                <b-button type="is-primary" @click="seeArchivedResources()" disabled>See resources</b-button>
              </div>
              </div>
          </div>

            <p><b>No. of resources:</b> {{!noArchived ? (noArchived === 0 ? noArchived : 'Calculating...') : noArchived}}</p>
            <p><b>Total size:</b> {{!totalSizeArchived ? (totalSizeArchived === 0 ? formatBytes(totalSizeArchived, 2) : 'Calculating...') : formatBytes(totalSizeArchived, 2)}}</p>
        </div>
        <div></div>
      </div>

    </div>
  </section>
</template>

<script>
import MenusResources from '@/components/storage/menus/MenusResources'
import MenusArchive from '@/components/storage/menus/MenusArchive'

export default {
  name: 'MenusStorage',
  data: () => {
    return {
      // loadingComponent: null,
      noArchived: null,
      totalSizeArchived: null,
      totalSizes: [],
      totalMenusSize: null,
      totalStorageSize: null,
      // freeStorageSize: null,
      totalPercentUsed: null,
      // totalPercentFree: null,
      menusPercent: null,
      shouldSeeResources: false,
      numMenRes: []
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    playlistsArchive () {
      return this.$store.state.playlistsArchive
    },
    /* menusArchive () {
      return this.$store.state.menusArchive
    }, */
    specialOffersArchive () {
      return this.$store.state.specialOffersArchive
    }
  },
  mounted: function () {
    this.loadArchiveData()
  },
  methods: {
    seeResources (id, name) {
      this.$buefy.modal.open({
        parent: this,
        component: MenusResources,
        props: { menuId: id, menuName: name },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd
      })
    },
    seeArchivedResources () {
      const modal = this.$buefy.modal.open({
        parent: this,
        component: MenusArchive,
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
      modal.$on('close', () => {
        this.showStorageData()
      })
    },
    formatBytes (bytes, decimals) {
      if (bytes === 0) {
        return '0 B'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    loadArchiveData () {
      let database = this.$store.state.database
      let store = this.$store
      if (!this.getNotMigrated().includes(store.state.uid)) {
        database.ref('/neoslide/archive/' + store.state.workspaceId + '/menus/').on('value', (snapshot) => {
          store.commit('setMenusArchive', snapshot.val())
        })
        database.ref('/neoslide/archive/' + store.state.workspaceId + '/playlists/').on('value', (snapshot) => {
          store.commit('setPlaylistsArchive', snapshot.val())
        })
        database.ref('/neoslide/archive/' + store.state.workspaceId + '/specialOffers/').on('value', (snapshot) => {
          store.commit('setSpecialOffersArchive', snapshot.val())
          this.showStorageData()
        })
      } else {
        database.ref('/archive/' + store.state.uid + '/menus/').on('value', (snapshot) => {
          store.commit('setMenusArchive', snapshot.val())
        })
        database.ref('/archive/' + store.state.uid + '/playlists/').on('value', (snapshot) => {
          store.commit('setPlaylistsArchive', snapshot.val())
        })
        database.ref('/archive/' + store.state.uid + '/specialOffers/').on('value', (snapshot) => {
          store.commit('setSpecialOffersArchive', snapshot.val())
          this.showStorageData()
        })
      }
    },
    showStorageData () {
      var menusArchive = this.$store.state.menusArchive
      this.totalSizes = []
      this.noArchived = 0
      this.totalStorageSize = 0
      this.totalSizeArchived = 0
      this.totalMenusSize = 0
      for (let menu in this.menus) {
        var sum = 0
        var menuRef = Object.assign({}, this.$store.getters.getMenu(menu))
        if (menuRef.items !== undefined) {
          var menuItems = [...menuRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          // this.globalLogger('menu items unfiltered: ', menuItems)
          menuItems = menuItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          // this.globalLogger('menu items filtered: ', menuItems)
          var noResources = menuItems.length
          this.numMenRes[menu] = noResources
          // this.numbersRes[playlist] = noResources
          if (noResources > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              if (menuItems[i].resourceName !== '') {
                sum += menuItems[i].resourceSize
              }
            }
            this.totalSizes.push({ 'key': menu, 'value': sum })
            this.totalStorageSize += sum
          }
          // this.totalPlaylistsSize
        } else {
          this.numMenRes[menu] = 0
          this.totalSizes.push({ 'key': menu, 'value': 0 })
        }
      }
      if (this.totalSizes.length > 0) {
        for (let j = 0; j < this.totalSizes.length; j++) {
          this.totalMenusSize += this.totalSizes[j].value
        }
      }
      // archive begin
      if (menusArchive !== null) {
        for (let i = 0; i < menusArchive.items.length; i++) {
          this.totalStorageSize += menusArchive.items[i].resSize
          this.totalMenusSize += menusArchive.items[i].resSize
          this.totalSizeArchived += menusArchive.items[i].resSize
          this.noArchived++
        }
      }
      if (this.noArchived > 0) {
        this.globalLogger('should see is true')
        this.shouldSeeResources = true
      } else {
        this.shouldSeeResources = false
      }
      if (this.playlistsArchive !== null) {
        for (let x = 0; x < this.playlistsArchive.items.length; x++) {
          this.totalStorageSize += this.playlistsArchive.items[x].resSize
        }
      }
      if (this.specialOffersArchive !== null) {
        for (let y = 0; y < this.specialOffersArchive.items.length; y++) {
          this.totalStorageSize += this.specialOffersArchive.items[y].resSize
        }
      }
      // archive end
      this.menusPercent = (this.totalMenusSize / 1073741824) * 100
      for (let playlist in this.playlists) {
        var sum1 = 0
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          playlistItems = playlistItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources1 = playlistItems.length
          if (noResources1 > 0) {
            for (let i = 0; i < playlistItems.length; i++) {
              if (playlistItems[i].resourceName !== '') {
                sum1 += playlistItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum1
          }
        }
      }
      for (let offer in this.specialOffers) {
        var sum2 = 0
        var offerRef = Object.assign({}, this.$store.getters.getSpecialOffer(offer))
        if (offerRef.items !== undefined) {
          var offerItems = [...offerRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          offerItems = offerItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources2 = offerItems.length
          if (noResources2 > 0) {
            for (let i = 0; i < offerItems.length; i++) {
              if (offerItems[i].resourceName !== '') {
                sum2 += offerItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum2
          }
        }
      }
      // this.freeStorageSize = 1073741824 - this.totalStorageSize
      this.totalPercentUsed = (this.totalStorageSize / 1073741824) * 100
      // this.totalPercentFree = (this.freeStorageSize / 1073741824) * 100
    },
    showName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/storage/menus/MenusStorage.vue